import EvolokActions from './EvolokActions'
let instance

export function getEvolokActions(user) {
  if (!instance) {
    instance = new EvolokActions(user)

    instance.init()
  }

  return instance
}
